import {productDispatchCopy} from './lennie-dispatch-copy.js?v=20260926-family-wording';
const uk = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'});
class LennieDispatch extends HTMLElement {
  connectedCallback(){this.update();this.timer=setInterval(()=>this.update(),60000);}
  disconnectedCallback(){clearInterval(this.timer);}
  update(){
    if(this.dataset.available!=='true'||this.dataset.physical!=='true')return;
    const target=this.querySelector('[data-dispatch-message]');
    try {
      const data=JSON.parse(this.querySelector('script').textContent);
      const parts=Object.fromEntries(uk.formatToParts(new Date()).map(p=>[p.type,p.value]));
      target.textContent=productDispatchCopy(data,`${parts.year}-${parts.month}-${parts.day}`);
    } catch {target.textContent='Dispatch time and your delivery estimate will be confirmed at checkout.';}
  }
}
if(!customElements.get('lennie-dispatch'))customElements.define('lennie-dispatch',LennieDispatch);

class LennieProductEstimate extends HTMLElement {
 connectedCallback(){this.update();this.timer=setInterval(()=>this.update(),30000);this.onToggle=()=>this.update();this.querySelector('details')?.addEventListener('toggle',this.onToggle);}
 disconnectedCallback(){clearInterval(this.timer);this.querySelector('details')?.removeEventListener('toggle',this.onToggle);}
 async update(){
  try{
   const {productEstimate,ukClock,shortDateRange}=await import('./lennie-product-estimate.js?v=20260926-two-three');
   if(!this.isConnected)return;
   const estimate=productEstimate(JSON.parse(this.querySelector('script').textContent),ukClock());
   const dates=this.querySelector('[data-estimate-dates]'),fallback=this.querySelector('[data-estimate-fallback]');
   dates.hidden=!estimate.available;fallback.hidden=estimate.available;
   if(estimate.available){this.querySelector('[data-estimate-dispatch]').textContent=shortDateRange(estimate.dispatchFrom,estimate.dispatchTo);this.querySelector('[data-estimate-arrival]').textContent=shortDateRange(estimate.arrivalFrom,estimate.arrivalTo);}
   else fallback.textContent=estimate.preorder?'Preorder dates depend on the release date. Check the product’s preorder information; checkout confirms your order’s estimate.':'Checkout will confirm the dispatch and delivery estimate for your order.';
  }catch{this.querySelector('[data-estimate-dates]').hidden=true;this.querySelector('[data-estimate-fallback]').hidden=false;}
 }
}
if(!customElements.get('lennie-product-estimate'))customElements.define('lennie-product-estimate',LennieProductEstimate);
